import { useEffect } from 'react';
import { useReadersStore } from '@/store/readers.store';
import { useRewardsStore } from '@/store/rewards.store';
import { useRewardsData } from '@/hooks/useRewardsData';
import { coinsService } from '@/services/coins.service';
import { AppShell } from '@/components/layout/AppShell';
import { PageLoader } from '@/components/layout/PageLoader';
import { RewardsHero } from '@/components/rewards/RewardsHero';
import { Hatchery } from '@/components/rewards/Hatchery';
import { EggShop } from '@/components/rewards/EggShop';
import { Nursery } from '@/components/rewards/Nursery';
import { RevealModal } from '@/components/rewards/RevealModal';
import { CreatureDetailModal } from '@/components/rewards/CreatureDetailModal';

export function RewardsPage() {
  const selectedReader = useReadersStore((s) => s.selectedReader());
  const setCoinBalance = useReadersStore((s) => s.setCoinBalance);
  const summary = useRewardsStore((s) => s.summary);

  // Fetch all rewards data on mount
  useRewardsData();

  // Hydrate coin balance for header chip
  useEffect(() => {
    if (!selectedReader) return;
    coinsService
      .getSummary(selectedReader.id)
      .then((s) => setCoinBalance(selectedReader.id, s.balance))
      .catch(() => {});
  }, [selectedReader?.id]);

  if (!selectedReader) {
    return (
      <AppShell>
        <PageLoader label="Loading rewards&hellip;" />
      </AppShell>
    );
  }

  const loading = !summary;

  return (
    <AppShell>
      <div className="mx-auto max-w-[1180px] px-5 py-8 space-y-12">
        {loading ? (
          <PageLoader label="Loading rewards&hellip;" />
        ) : (
          <>
            <RewardsHero />
            <Hatchery />
            <EggShop />
            <Nursery />
          </>
        )}
      </div>

      <RevealModal />
      <CreatureDetailModal />
    </AppShell>
  );
}
